import { Booking } from "use-smart-locks-shared";
import { useBookingQuery } from "../../shared/queries/use-booking-query";
import { useCampingBookingSlug } from "./use-camping-booking-slug";

export const useCampingBooking = (): {
  booking: Booking;
  hasMultipleUnits: boolean;
  hasBluetoothLock: boolean;
  hasLock: boolean;
  hasEBike: boolean;
  requiresLocationVerification: boolean;
} => {
  const bookingSlug = useCampingBookingSlug();

  const { data } = useBookingQuery(bookingSlug);

  const hasMultipleUnits = data.units.length > 1;
  const hasBluetoothLock = data.units.some((unit) => unit.hasBluetoothLock);
  const hasLock = data.units.some((unit) => unit.hasLock);
  const hasEBike = data.units.some((unit) => unit.unitType === "e-bike");
  const requiresLocationVerification = data.units.some(
    (unit) => unit.enableLocationVerification,
  );

  return {
    booking: data,
    hasMultipleUnits,
    hasBluetoothLock,
    hasLock,
    hasEBike,
    requiresLocationVerification,
  };
};
